export default "__VITE_ASSET__916bb5cd__"